import { PORTAL_PATHS } from '@/domains/survey';

/**
 * The Advisor Portal's navigation (the two-portals design, §3.1). Its own, like the Team Portal's
 * (`zones/team/nav.ts`): neither names a route of the other. Every entry is a live screen — an
 * external advisor is not shown an entry that is not real (ruled 2026-09-28).
 */
export interface IPortalNavEntry {
  label: string;
  to: string;
  /** Match exactly: Home, whose path every other entry starts with. */
  end?: boolean;
}

export const PORTAL_NAV: IPortalNavEntry[] = [
  { label: 'Home', to: PORTAL_PATHS.home, end: true },
  { label: 'My surveys', to: PORTAL_PATHS.surveys },
  { label: 'Profile & numbers', to: PORTAL_PATHS.profile },
  { label: 'Documents', to: PORTAL_PATHS.documents },
  { label: 'Account', to: PORTAL_PATHS.account },
  { label: 'Help', to: PORTAL_PATHS.help }
];
